import React, { useRef, useEffect } from "react";

/**
 * Hook that alerts clicks outside of the passed ref
 */
function useOutsideAlerter(ref: any, func: (b:boolean) => void) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target)) {
        func(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, func]);
}

/**
 * Component that alerts if you click outside of it
 */
function OutsideAlerter(props: { children: any; func: (b: boolean) => void }) {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, props.func);

  return <div ref={wrapperRef}>{props.children}</div>;
}

export default OutsideAlerter;
